import React, { useEffect, useState, useRef } from 'react';
import ManagerItem from './ManagerItem';
import { useNavigate } from 'react-router-dom';
import { Grid, GridColumn as Column, GridNoRecords, GRID_COL_INDEX_ATTRIBUTE } from '@progress/kendo-react-grid';
import { Loader } from "@progress/kendo-react-indicators";
import { getter } from "@progress/kendo-react-common";
import { useManagers, getManagers, getLookup, setCurrent, clearSuccess, clearErrors, deleteManager } from '../../context/managers/ManagersState';
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Dialog } from '@progress/kendo-react-dialogs';
import AlertContext from "../../context/alert/alertContext";
import { useContext } from 'react';

const DATA_ITEM_KEY = "id";

const idGetter = getter(DATA_ITEM_KEY);

const Managers = (from) => {
    const [managersState, managersDispatch] = useManagers();
    const { managers, columns, labels, actions, error, count, loading, current, success } = managersState;
    const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;

    useEffect(() => {
        
        if (success !== "" && success !== null) {
            setAlert(success, "success");
            clearSuccess(managersDispatch);
        }
    }, [success, managersDispatch]);


    useEffect(() => {

        if (error !== "" && error !== null && typeof error === 'string') { 
            setAlert(error, "danger");
            clearErrors(managersDispatch);
        }
    }, [error, managersDispatch]);

    const navigate = useNavigate();
    // state is used for pagination and search
    const createState = (skip, take, search) => {
        return {
            pageNumber: skip / take + 1,
            skip: skip,
            take: take,
            search: search
        };
    };

    const actionsCell = (props) => {
    const style = {
      cursor: props.dataItem.showId && !loading ? "pointer" : "",
      paddingTop: 0,
      paddingBottom: 0,
    };
    
    return (
      <td
        style={style}
        colSpan={props.colSpan}
        role={"gridcell"}
        aria-colindex={props.ariaColumnIndex}
      >
        {props.dataItem.actions?.indexOf("remove") > -1 && (
          <button className="actions" onClick={() => managersDispatch(deleteManager(managersDispatch, props.dataItem))}>
            <Tooltip anchorElement="target" position="top">
              <i className="far fa-trash-alt" title="מחיקה"></i>
            </Tooltip>
          </button>
        )}
        {props.dataItem.actions?.indexOf("edit") > -1 && (
          <button className="actions" onClick={() => setCurrent(managersDispatch, props.dataItem)}>
            <Tooltip anchorElement="target" position="top">
              <i className="far fa-edit" title="עריכה"></i>
            </Tooltip>
          </button>
        )}
      </td>
    );
  };
    // sorting data
    const initialSort = [
        {
            field: "id",
            dir: "asc",
        },
    ];

    const [state, setState] = useState(createState(0, 20, ''));
    const [sort, setSort] = useState(initialSort);

    // setting pagination
    const pageChange = (event) => {
        setState(createState(event.page.skip, event.page.take, state.search, state.sort));
    };

    // setting sort
    const sortClick = (event) => {
        setSort(event.sort);
    };

    // setting search
    const onChange = e => {
        setState(createState(0, state.take, e.target.value));
    }

    const onSubmit = e => {
        e.preventDefault();
    }

    // getting lookup at the first load
    useEffect(() => {
        if (!columns.length) {
            getLookup(managersDispatch);
        }
    }, [managersDispatch]);

    // getting managers of current page with search and sort
    useEffect(() => {
        getManagers(managersDispatch, state.pageNumber, state.search, sort[0]);
    }, [managersDispatch, state.pageNumber, state.search, sort]);
    
    

    // if UnAuthorized - refresh page
    useEffect(() => {
        if (typeof error !== 'undefined' && 
            error !== null && 
            typeof error.data !== 'undefined' &&
            error.data.status === 401) {
            window.location.reload();
        }
    }, [error]);
    
    return (
        <div className='divAllPage managers'>
            <div className='divAllPage_R'>
                <div className='search searchDisplay'>

                    <div className="search_wrapper">
                        <form onSubmit={onSubmit}>
                            <div className='searchNameId'>
                                <i className="fas fa-search"></i>
                                <input className='textCss nameIdInput' type="text" placeholder="הקלידו שם / ID" onChange={onChange} />
                            </div>
                        </form>

                    </div>
                    <button id='btnNewManager' className='btn' onClick={() => setCurrent(managersDispatch, {name: "", phone: "", email: ""})}>
                        <i className="fas fa-user-plus" key={1} ></i>
                        <span>מנהל חדש</span>
                    </button>
                </div>
                <div className='divWarpGrid'>
                    <div className={loading ? 'loading divWarpGrid_wrapper' : 'divWarpGrid_wrapper'} dir='rtl'>
                        {loading && <Loader type="infinite-spinner"/>}
                        
                            <Grid
                                data={managers.map((item) => ({
                                    ...item,
                                    
                                }))}
                                skip={state.skip}
                                take={state.take}
                                total={count}
                                //sort={sort}
                                pageable={{
                                    buttonCount: 10,
                                    info: true,
                                    type: "numeric",
                                    previousNext: true,
                                }}
                                onPageChange={pageChange}
                                sortable={false}
                                //onSortChange={sortClick}
                                >
                                {(columns ?? []).map((column) => {
                                    return column === "actions" ? (
                                        <Column
                                        key={column}
                                        field={column}
                                        title={labels[column]}
                                        cells={{
                                            data: props => actionsCell(props)
                                        }}
                                        />
                                    ) : (
                                        <Column
                                        key={column}
                                        field={column}
                                        title={labels[column]}
                                        />
                                    );
                                })}
                            </Grid>
                    </div>
                </div>
               
            </div>
            {current && (
                <Dialog title='פרטי מנהל'
                onClose={() => setCurrent(managersDispatch, null)}
                className="pop-up pop-up-manager">
                    <ManagerItem manager={current}/>
                </Dialog>
            )}

        </div>
    );
}
export default Managers;


